export default {
    en: {
        title: `Faculty of Social Sciences, Srinakharinwirot University`,
        description: `The Faculty of Social Sciences aims to produce and develop human resources to have Academic knowledge, morality, ethics and responsibility Able to apply knowledge to benefit society.`,
        
        menu: "Menu",
        back: 'Back',
        Home: 'Home',
        Profile: 'Profile',
        Project: 'Project',
        Login: 'Log In',
        Logout: 'Log Out',
        copyright: 'Copyright © 2022 Faculty of Social Sciences, Srinakharinwirot University',

        footerFollow: 'Follow Us',
        footerLink: 'Links',
        footerDepartment: 'Department',
        footerContact: 'Contact',
        search: 'Search',
        newsMore: 'more',
        SeeMoreNews: 'See More News',

        Personnel: 'Personnel',
        Program: 'Program',
        Student: 'Student',
        
    },
    th: {
        title: `คณะสังคมศาสตร์ มหาวิทยาลัยศรีนครินทรวิโรฒ`,
        description: `คณะสังคมศาสตร์มุ่งหวังที่จะผลิตพัฒนาทรัพยากรบุคคลให้มี ความรอบรู้ในวิชาการ มีคุณธรรม จริยธรรม และมีความรับผิดชอบ สามารถนำความรู้ไปใช้ให้เป็นประโยชน์แก่สังคม`,

        menu: "เมนู",
        back: 'ย้อนกลับ',
        Home: 'หน้าแรก',
        Profile: 'โปรไฟล์',
        Project: 'โครงการ',
        Login: 'เข้าสู่ระบบ',
        Logout: 'ออกจากระบบ',
        copyright: 'สงวนลิขสิทธิ์ © 2022 คณะสังคมศาสตร์, มหาวิทยาลัยศรีนครินทรวิโรฒ',

        footerFollow: 'ติดตามเรา',
        footerLink: 'ลิงค์แนะนำ',
        footerDepartment: 'หน่วยงานภายใน',
        footerContact: 'ติดต่อคณะสังคมศาสตร์',
        search: 'ค้นหา',
        newsMore: 'อ่านต่อ',
        SeeMoreNews: 'ดูข่าวเพิ่มเติม',

        Personnel: 'บุคลากร',
        Program: 'หลักสูตร',
        Student: 'นิสิต',

        
    }
}